(function ($) {
  'use strict';

  // DOM Ready
  $(document).ready(function () {
    initMobileNav();
    initSmoothScroll();
    initAmenitiesTabs();
    initFormValidation();
    initHeaderScroll();

    initHeroSlider();
    initLazySliders();

    // Re-initialize responsive sliders on resize with debouncing
    var resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initWhyChooseSlider();
        initAmenitiesSlider();
      }, 150);
    });
  });

  function initLazySliders() {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var target = entry.target;
            if ($(target).hasClass('landmarks') || $(target).find('.landmarks__slider').length) {
              initLandmarksSlider();
            }
            if ($(target).hasClass('whyTreetopia') || $(target).find('.whyTreetopia__wrap').length) {
              initWhyChooseSlider();
            }
            if ($(target).hasClass('amenities') || $(target).find('.amenities__panel').length) {
              initAmenitiesSlider();
            }
            observer.unobserve(target);
          }
        });
      }, { rootMargin: '300px 0px' });

      var sections = document.querySelectorAll('.landmarks, .whyTreetopia, .amenities');
      sections.forEach(function (section) {
        observer.observe(section);
      });
    } else {
      setTimeout(function () {
        initLandmarksSlider();
        initWhyChooseSlider();
        initAmenitiesSlider();
      }, 800);
    }
  }

  /**
   * Mobile Navigation
   */
  function initMobileNav() {
    var $toggle = $('.header__mobile-toggle');
    var $mobileNav = $('.mobile-nav');
    var $overlay = $('.mobile-nav-overlay');
    var $closeBtn = $('.mobile-nav__close');
    var $navLinks = $('.mobile-nav a');

    function openNav() {
      $mobileNav.addClass('active');
      $overlay.addClass('active');
      $toggle.addClass('active');
      $('body').css('overflow', 'hidden');
    }

    function closeNav() {
      $mobileNav.removeClass('active');
      $overlay.removeClass('active');
      $toggle.removeClass('active');
      $('body').css('overflow', '');
    }

    $toggle.on('click', function () {
      if ($mobileNav.hasClass('active')) {
        closeNav();
      } else {
        openNav();
      }
    });

    $closeBtn.on('click', closeNav);
    $overlay.on('click', closeNav);
    $navLinks.on('click', closeNav);
  }

  // Track whether a brochure download was requested
  var brochureDownloadPending = false;

  $(".form-popup, .btn-download-brochure").click(function () {
    if ($(this).hasClass('btn-download-brochure')) {
      brochureDownloadPending = true;
    }
    $(".form-overlay").addClass("active");
  });

  $(".form-close").click(function () {
    var $overlay = $(".form-overlay");
    $overlay.removeClass("active");
    brochureDownloadPending = false;
    $overlay.find('form').show().trigger('reset');
    $overlay.find('h3').show();
    $overlay.find('.form-message').remove();
  });
  /**
   * Smooth Scroll
   */
  function initSmoothScroll() {
    $('a[href^="#"]').on('click', function (e) {
      var target = $(this.getAttribute('href'));

      if (target.length) {
        e.preventDefault();
        var offset = $(window).width() <= 992 ? 60 : 80;

        $('html, body').animate({
          scrollTop: target.offset().top - offset
        }, 800);
      }
    });
  }

  /**
   * Hero Banner Slider
   */
  function initHeroSlider() {
    var $slider = $('.hero__slider');
    if ($slider.length === 0) return;

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: true,
      speed: 1000,
      cssEase: 'ease-in-out',
      pauseOnHover: false,
      pauseOnFocus: false
    });
  }

  /**
   * Landmarks Slider (Full-width carousel)
   */
  function initLandmarksSlider() {
    var $slider = $('.landmarks__slider');
    var $counter = $('.landmarks__counter');

    if ($slider.length === 0) return;

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      prevArrow: '.landmarks-prev',
      nextArrow: '.landmarks-next',
      fade: false,
      speed: 600,
      cssEase: 'ease-in-out',
      centerMode: false,
      // centerPadding: '200px',
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            // centerPadding: '100px'
          }
        },
        {
          breakpoint: 1200,
          settings: {
            // centerPadding: '60px'
          }
        },
        {
          breakpoint: 992,
          settings: {
            // centerPadding: '40px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            // centerPadding: '20px'
            variableWidth: true,
          }
        }
      ]
    });

    // Update counter on slide change
    $slider.on('afterChange', function (event, slick, currentSlide) {
      var current = (currentSlide + 1).toString().padStart(2, '0');
      var total = slick.slideCount.toString().padStart(2, '0');
      $counter.find('.current').text(current + '/');
      $counter.find('.total').text(total);
    });
  }

  /**
  * whychoose Slider (Full-width carousel)
  */
  function initWhyChooseSlider() {
    var $slider = $('.whyTreetopia__wrap');

    if (window.innerWidth <= 992) {

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
          arrows: true,
          prevArrow: '.whychoose-prev',
          nextArrow: '.whychoose-next',
          speed: 600,
          cssEase: 'ease-in-out',
          variableWidth: true, // 🔥 IMPORTANT
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }

    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }


  /**
   * Amenities Slider
   */
  function initAmenitiesSlider() {
    initAmenitiesSlidersForPanel($('.amenities__panel.active'));
  }

  function initAmenitiesSlidersForPanel($panel) {
    var $slider = $panel.find('.amenities-slider');

    if ($slider.length === 0) return;
    $panel[0].offsetHeight;
    // Destroy existing slick instance if exists
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    var slidesCount = 3;

    if (window.innerWidth <= 768) {
      slidesCount = 1;
    } else if (window.innerWidth <= 1200) {
      slidesCount = 2;
    }
    $slider.slick({
      slidesToShow: slidesCount,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true,
      prevArrow: $panel.find('.amenities-prev'),
      nextArrow: $panel.find('.amenities-next'),
      speed: 500,
      cssEase: 'ease-in-out',
      centerMode: false,
      centerPadding: '40px',
      variableWidth: window.innerWidth <= 768,
      adaptiveHeight: true
    });
    setTimeout(function () {
      $slider.slick('setPosition');
    }, 50);
  }

  /**
   * Amenities Tabs
   */
  function initAmenitiesTabs() {
    var $tabs = $('.amenities__tab');
    var $panels = $('.amenities__panel');

    $tabs.on('click', function () {
      var tabId = $(this).data('tab');

      // Update active states
      $tabs.removeClass('active');
      $(this).addClass('active');

      $panels.removeClass('active');
      var $activePanel = $panels.filter('[data-panel="' + tabId + '"]');
      $activePanel.addClass('active');

      // Initialize slider for active panel
      initAmenitiesSlidersForPanel($activePanel);
    });

    // Auto open first tab on mobile if none active
    if (window.innerWidth <= 767 && !$tabs.filter('.active').length) {
      $tabs.first().trigger('click');
    }
  }

  /**
   * Form Validation & Lazy Phone Input
   */
  function initFormValidation() {

    /* ---------------- UTM AUTO MAP ---------------- */
    function getUTMs() {
      const p = new URLSearchParams(window.location.search);
      return {
        utm_source: p.get('utm_source') || '',
        utm_medium: p.get('utm_medium') || '',
        utm_campaign: p.get('utm_campaign') || '',
        utm_term: p.get('utm_term') || '',
        utm_content: p.get('utm_content') || ''
      };
    }
    const utms = getUTMs();

    /* ---------------- INTL TEL INPUT (Lazy-Loaded On Demand) ---------------- */
    const phoneInstances = new Map();
    let itiLoading = false;
    let itiLoaded = false;
    const itiCallbacks = [];

    function loadIntlTelInput(cb) {
      if (itiLoaded || typeof window.intlTelInput === 'function') {
        itiLoaded = true;
        initPhoneFields();
        if (cb) cb();
        return;
      }
      if (cb) itiCallbacks.push(cb);
      if (itiLoading) return;
      itiLoading = true;

      // Inject stylesheet
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/intl-tel-input@26.0.6/build/css/intlTelInput.min.css';
      document.head.appendChild(link);

      // Inject script
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/intl-tel-input@26.0.6/build/js/intlTelInput.min.js';
      script.onload = function () {
        itiLoaded = true;
        initPhoneFields();
        itiCallbacks.forEach(function (fn) { fn(); });
        itiCallbacks.length = 0;
      };
      document.body.appendChild(script);
    }

    function initPhoneFields() {
      if (typeof window.intlTelInput !== 'function') return;
      $('input.phone-field').each(function () {
        if (phoneInstances.has(this)) return;
        // Popup form: render the country list on <body> so the modal's
        // scroll area can't clip it. Bottom strip keeps the inline list.
        const inPopup = $(this).closest('.form-overlay').length > 0;
        const iti = window.intlTelInput(this, {
          dropdownContainer: inPopup ? document.body : null,
          initialCountry: 'in',
          separateDialCode: true,
          showFlags: true,
          nationalMode: true,
          autoHideDialCode: false,
          preferredCountries: ['in', 'ae', 'us'],
          utilsScript:
            'https://cdn.jsdelivr.net/npm/intl-tel-input@26.0.6/build/js/utils.js'
        });
        phoneInstances.set(this, iti);
      });
    }

    // Lazy load triggers
    $('body').one('focus', 'input.phone-field', function () {
      loadIntlTelInput();
    });
    $('.form-popup, .btn-download-brochure').one('mouseenter click', function () {
      loadIntlTelInput();
    });

    if ('IntersectionObserver' in window) {
      const formObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadIntlTelInput();
            formObserver.disconnect();
          }
        });
      }, { rootMargin: '200px 0px' });
      const forms = document.querySelectorAll('.form-strip, .form-overlay');
      forms.forEach(function (f) { formObserver.observe(f); });
    } else {
      setTimeout(loadIntlTelInput, 2500);
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        loadIntlTelInput();
      }, { timeout: 3500 });
    }

    /* ---------------- PREVENT SPACE AT FIRST CHAR ---------------- */
    $('input').on('keydown', function (e) {
      if (e.key === ' ' && this.selectionStart === 0) {
        e.preventDefault();
      }
    });

    /* ---------------- INPUT FIELD RESTRICTIONS ---------------- */
    $('.name-field').on('input', function () {
      this.value = this.value
        .replace(/[^a-zA-Z\s]/g, '')
        .slice(0, 50);
    });

    /* ---------------- OTP STATE & LOGIC ---------------- */
    const otpVerified = {};
    const otpRequestInProgress = {};
    const resendCooldownTimers = {};
    const submitAfterVerify = {};
    window.otpVerified = otpVerified;

    $('.phone-field').on('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 10);
      const formId = $(this).closest('form').attr('id');
      if (formId) {
        otpVerified[formId] = false;
        $('#' + formId + '-otpbox').slideUp(150);
        $('#' + formId + ' input[name="otp"]').val('').prop('readonly', false).removeClass('verified error');
        $('#' + formId + '-otp-msg').text('').removeClass('success error info');
      }
    });

    $(document).on('input paste', 'input[name="otp"]', function () {
      const inputEl = this;
      setTimeout(function () {
        inputEl.value = inputEl.value.replace(/\D/g, '').slice(0, 6);
        const formId = $(inputEl).closest('form').attr('id');
        // Only verify here; the lead is sent when the user clicks Submit
        if (formId && inputEl.value.length === 6 && !otpVerified[formId] && !otpRequestInProgress[formId]) {
          verifyOtp(formId, false);
        }
      }, 15);
    });

    function startResendTimer(formId) {
      const $btn = $('#' + formId + '-resend');
      const $timer = $('#' + formId + '-resend-timer');
      if (!$btn.length) return;

      if (resendCooldownTimers[formId]) clearInterval(resendCooldownTimers[formId]);
      $btn.prop('disabled', true);
      let remaining = 30;
      $timer.text('(' + remaining + 's)');

      resendCooldownTimers[formId] = setInterval(function () {
        remaining--;
        if (remaining <= 0) {
          clearInterval(resendCooldownTimers[formId]);
          $btn.prop('disabled', false);
          $timer.text('');
        } else {
          $timer.text('(' + remaining + 's)');
        }
      }, 1000);
    }

    function sendOtp(formId) {
      if (otpRequestInProgress[formId]) return;
      const $form = $('#' + formId);
      const fullName = ($form.find("[name='fullName']").val() || '').trim();
      const email = ($form.find("[name='email']").val() || '').trim();
      const mobile = ($form.find("[name='mobile']").val() || '').replace(/\D/g, '');
      const $btn = $form.find('button[type="submit"]');
      const $otpBox = $('#' + formId + '-otpbox');
      const $otpMsg = $('#' + formId + '-otp-msg');

      if (!fullName) {
        $form.find("[name='fullName']").addClass('error').focus();
        return;
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        $form.find("[name='email']").addClass('error').focus();
        return;
      }
      if (mobile.length !== 10) {
        $form.find("[name='mobile']").addClass('error').focus();
        return;
      }

      otpRequestInProgress[formId] = true;
      $btn.prop('disabled', true).text('Sending OTP...');
      $otpMsg.removeClass('error success info').text('');

      $.ajax({
        url: 'sendotp.php',
        type: 'POST',
        contentType: 'application/json',
        xhrFields: { withCredentials: true },
        data: JSON.stringify({
          fname: fullName,
          fullName: fullName,
          email: email,
          mobile: mobile,
          source: formId.indexOf('strip') !== -1 ? 'Bottom Strip Form' : 'Popup Form'
        }),
        dataType: 'json',
        success: function (res) {
          $btn.prop('disabled', false).html('<svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"><path d="M0.562535 12.375C0.418676 12.375 0.274676 12.32 0.164848 12.2102C-0.0549492 11.9904 -0.0549492 11.6345 0.164848 11.4148L5.39216 6.18748L0.164848 0.96017C-0.0549492 0.740373 -0.0549492 0.384451 0.164848 0.164795C0.384645 -0.0548613 0.740566 -0.0550019 0.960222 0.164795L6.58522 5.78979C6.80502 6.00959 6.80502 6.36551 6.58522 6.58517L0.960222 12.2102C0.850394 12.32 0.706394 12.375 0.562535 12.375Z" fill="#ffffff" /></svg> Submit Now');
          if (res.status === 'success' || res.status === 200 || res.status === '200' || res.success) {
            $otpBox.slideDown(200);
            $otpMsg.removeClass('error info').addClass('success').text('OTP sent to your mobile number');
            startResendTimer(formId);
            $form.find('input[name="otp"]').val('').prop('readonly', false).removeClass('verified error').focus();
          } else {
            $otpBox.slideDown(200);
            $otpMsg.removeClass('success info').addClass('error').text(res.message || 'Failed to send OTP. Please try again.');
          }
        },
        error: function () {
          $btn.prop('disabled', false).html('<svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"><path d="M0.562535 12.375C0.418676 12.375 0.274676 12.32 0.164848 12.2102C-0.0549492 11.9904 -0.0549492 11.6345 0.164848 11.4148L5.39216 6.18748L0.164848 0.96017C-0.0549492 0.740373 -0.0549492 0.384451 0.164848 0.164795C0.384645 -0.0548613 0.740566 -0.0550019 0.960222 0.164795L6.58522 5.78979C6.80502 6.00959 6.80502 6.36551 6.58522 6.58517L0.960222 12.2102C0.850394 12.32 0.706394 12.375 0.562535 12.375Z" fill="#ffffff" /></svg> Submit Now');
          $otpBox.slideDown(200);
          $otpMsg.removeClass('success info').addClass('error').text('Server error. Failed to send OTP.');
        },
        complete: function () {
          otpRequestInProgress[formId] = false;
        }
      });
    }

    function verifyOtp(formId, autoSubmit) {
      const $form = $('#' + formId);
      const $otpInput = $form.find('input[name="otp"]');
      const otpVal = ($otpInput.val() || '').replace(/\D/g, '');
      const mobileVal = ($form.find("[name='mobile']").val() || '').replace(/\D/g, '');
      const $otpMsg = $('#' + formId + '-otp-msg');

      if (otpVerified[formId]) {
        if (autoSubmit) {
          submitLeadPayload($form);
        }
        return;
      }

      if (otpRequestInProgress[formId]) {
        // Submit clicked while the automatic check is still running:
        // send the lead once that check succeeds
        if (autoSubmit) submitAfterVerify[formId] = true;
        return;
      }

      if (otpVal.length !== 6) {
        $otpMsg.removeClass('success info').addClass('error').text('Please enter the 6-digit OTP');
        $otpInput.focus();
        return;
      }

      otpRequestInProgress[formId] = true;
      $otpMsg.removeClass('error success').addClass('info').text('Verifying OTP...');

      $.ajax({
        url: 'verifyotp.php',
        type: 'POST',
        contentType: 'application/json',
        xhrFields: { withCredentials: true },
        data: JSON.stringify({ otp: otpVal, mobile: mobileVal }),
        dataType: 'json',
        success: function (res) {
          if (res.status === 'success') {
            otpVerified[formId] = true;
            $otpInput.prop('readonly', true).removeClass('error').addClass('verified');
            $otpMsg.removeClass('error info').addClass('success').text('✓ Mobile Number Verified!');
            if (autoSubmit || submitAfterVerify[formId]) {
              submitLeadPayload($form);
            }
          } else {
            $otpInput.removeClass('verified').addClass('error');
            $otpMsg.removeClass('success info').addClass('error').text(res.message || 'Invalid OTP. Please try again.');
          }
        },
        error: function () {
          $otpMsg.removeClass('success info').addClass('error').text('Failed to verify OTP. Please try again.');
        },
        complete: function () {
          otpRequestInProgress[formId] = false;
          submitAfterVerify[formId] = false;
        }
      });
    }

    $(document).on('click', '.resend-otp-btn', function (e) {
      e.preventDefault();
      const formId = $(this).closest('form').attr('id');
      if (formId && !$(this).prop('disabled')) {
        sendOtp(formId);
      }
    });

    window.send_otp = sendOtp;
    window.resend_otp = sendOtp;
    window.otp_varify = verifyOtp;

    /* ---------------- LEAD SUBMISSION ---------------- */
    function submitLeadPayload($form) {
      const formId = $form.attr('id');
      const fullNameVal = ($form.find("[name='fullName']").val() || '').trim();
      const mobileVal = ($form.find("[name='mobile']").val() || '').replace(/\D/g, '');
      const phoneInput = $form.find('input.phone-field')[0];
      const iti = phoneInstances.get(phoneInput);
      const countryData = (iti && typeof iti.getSelectedCountryData === 'function')
        ? iti.getSelectedCountryData()
        : { dialCode: '91', name: 'India' };

      const payload = {
        fullName: fullNameVal,
        fname: fullNameVal,
        email: ($form.find("[name='email']").val() || '').trim(),
        mobileNumber: mobileVal,
        mobile: mobileVal,
        dialingCode: '+' + (countryData.dialCode || '91'),
        country: countryData.name || 'India',
        budget: $form.find("[name='budget']").val() || '',
        interest: $form.find("[name='interest']").val() || '',
        source: formId.indexOf('strip') !== -1 ? 'Bottom Strip Form' : 'Popup Form',
        utm_source: utms.utm_source,
        utm_medium: utms.utm_medium,
        utm_campaign: utms.utm_campaign,
        utm_term: utms.utm_term,
        utm_content: utms.utm_content,
      };

      const $btn = $form.find('button[type="submit"]');
      let $msg = $form.find('.form-message');
      if (!$msg.length) {
        $msg = $('<div class="form-message"></div>').appendTo($form);
      }

      $btn.prop('disabled', true).text('Submitting...');

      $.ajax({
        url: 'send.php',
        type: 'POST',
        data: payload,
        dataType: 'json',
        xhrFields: { withCredentials: true },
        success: function (res) {
          if (res.success) {
            $form[0].reset();
            otpVerified[formId] = false;
            $('#' + formId + '-otpbox').hide();
            $('#' + formId + ' input[name="otp"]').val('').prop('readonly', false).removeClass('verified error');
            $('#' + formId + '-otp-msg').text('');

            var brochureHref = $('#brochure-download-link').attr('href') || 'dist/brochure/Treetopia-Brochure-Life-Will-Thank-You.pdf';
            var brochureName = $('#brochure-download-link').attr('download') || 'Treetopia-Brochure.pdf';
            var thankYouText = brochureDownloadPending ? 'Thank you! Your brochure is ready.' : 'Thank you! We will contact you shortly.';
            brochureDownloadPending = false;

            var brochureBtn = '<a href="' + brochureHref + '" download="' + brochureName + '" class="btn btn--primary brochure-download-btn">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>' +
              ' Download Brochure</a>';

            if ($form.closest('.form-overlay').length) {
              var $inner = $form.closest('.form-overlay-inner');
              $form.hide();
              $inner.find('h3').hide();
              $msg
                .removeClass('error')
                .addClass('success brochure-success')
                .html('<span class="brochure-thankyou">' + thankYouText + '</span>' + brochureBtn)
                .appendTo($inner)
                .fadeIn();
            } else {
              $msg
                .removeClass('error')
                .addClass('success brochure-success')
                .html(brochureBtn)
                .fadeIn();
            }
          } else {
            $msg.removeClass('success').addClass('error').text(res.message || 'Submission failed.').fadeIn();
          }

          try {
            gtag('event', 'form_submit', { form_name: 'Enquiry Form' });
          } catch (e) { }
        },
        error: function () {
          $msg.removeClass('success').addClass('error').text('Server error. Please try again later.').fadeIn();
        },
        complete: function () {
          $btn.prop('disabled', false).html('<svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"><path d="M0.562535 12.375C0.418676 12.375 0.274676 12.32 0.164848 12.2102C-0.0549492 11.9904 -0.0549492 11.6345 0.164848 11.4148L5.39216 6.18748L0.164848 0.96017C-0.0549492 0.740373 -0.0549492 0.384451 0.164848 0.164795C0.384645 -0.0548613 0.740566 -0.0550019 0.960222 0.164795L6.58522 5.78979C6.80502 6.00959 6.80502 6.36551 6.58522 6.58517L0.960222 12.2102C0.850394 12.32 0.706394 12.375 0.562535 12.375Z" fill="#ffffff" /></svg> Submit Now');
          if (!$msg.hasClass('brochure-success')) {
            setTimeout(() => $msg.fadeOut(), 5000);
          }
        }
      });
    }

    /* ---------------- FORM SUBMIT HANDLER ---------------- */
    $('form[id^="enquiry-form"]').on('submit', function (e) {
      e.preventDefault();

      const $form = $(this);
      const formId = $form.attr('id');
      let isValid = true;

      $form.find('input.error, select.error').removeClass('error');

      $form.find('input[required]').each(function () {
        const $input = $(this);
        const value = $.trim($input.val());

        if (!value) {
          isValid = false;
          $input.addClass('error');
          return;
        }

        /* EMAIL */
        if ($input.attr('type') === 'email') {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) {
            isValid = false;
            $input.addClass('error');
          }
        }

        /* PHONE */
        if ($input.hasClass('phone-field')) {
          const number = value.replace(/\D/g, '');

          // Minimum 10 digits for India
          if (number.length < 10) {
            isValid = false;
            $input.addClass('error');
            return;
          }

          // First digit must be >= 6
          if (number.charAt(0) < '6') {
            isValid = false;
            $input.addClass('error');
          }
        }
      });

      if (!isValid) return false;

      // Check OTP verification
      if (!otpVerified[formId]) {
        const $otpBox = $('#' + formId + '-otpbox');
        const otpVal = ($form.find('input[name="otp"]').val() || '').replace(/\D/g, '');
        if ($otpBox.is(':visible') && otpVal.length === 6) {
          verifyOtp(formId, true);
        } else {
          sendOtp(formId);
        }
        return false;
      }

      submitLeadPayload($form);
    });

    /* ---------------- REMOVE ERROR ON INPUT ---------------- */
    $('input').on('input', function () {
      $(this).removeClass('error');
    });
  }

  /**
   * Header Scroll Effect
   */
  function initHeaderScroll() {
    var $header = $('.header');
    var scrollThreshold = 100;

    $(window).on('scroll', function () {
      if ($(window).scrollTop() > scrollThreshold) {
        $header.addClass('scrolled');
      } else {
        $header.removeClass('scrolled');
      }
    });
  }

  // Add CSS for scrolled header and form error states
  var dynamicStyles = document.createElement('style');
  dynamicStyles.textContent = `
    .header.scrolled {
      position: fixed;
      background: rgba(255, 255, 255, 0.98);
      box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
      padding: 10px 0;
    }

    .header.scrolled .header__logo img {
      height: 30px;
    }
    .header.scrolled .header__logo .sp-logo{
      height:40px;
    }
  `;
  document.head.appendChild(dynamicStyles);

})(jQuery);
